module.exports = __webpack_public_path__ + "static/media/Tarun Tapadiya.c450a56f.jpg";